// extracted by mini-css-extract-plugin
export var icon = "_41-1";
export var subtext = "_41-0";